import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/jumprope-match/361du/Index.vue')
const IndexMetaSVS2024 = () => import('../activity/jumprope-match/metasvs-2024/Index.vue')
const IndexSplus202409 = () => import('../activity/jumprope-match/splus-202409/Index.vue')
const RewardsSplus202409 = () => import('../activity/jumprope-match/splus-202409/Rewards.vue')
const RewardsMetaSVS2024 = () => import('../activity/jumprope-match/metasvs-2024/Rewards.vue')
const PhysicalRewardSizeEdit = () => import('../activity/jumprope-match/361du/PhysicalRewardSizeEdit.vue')
const PhysicalRewardSizeEditMetaSVS2024 = () =>
  import('../activity/jumprope-match/metasvs-2024/PhysicalRewardSizeEdit.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/jumprope-match/361du',
  name: 'activity_jumprope_match_361du',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '361°全民亿起跳绳',
  },
}

export const indexMetaSVS2024Route: RouteConfig = {
  path: '/activity/jumprope-match/metasvs-2024',
  name: 'activity_jumprope_match_metasvs_2024',
  component: IndexMetaSVS2024,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2024 MetaSVS上海虚拟体育公开赛',
  },
}

export const indexSplus202409Route: RouteConfig = {
  path: '/activity/jumprope-match/splus-202409',
  name: 'activity_jumprope_match_splus_202409',
  component: IndexSplus202409,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '「开学乐活」跳绳赛',
  },
}

export const rewardsSplus202409Route: RouteConfig = {
  path: '/activity/jumprope-match/splus-202409/rewards',
  name: 'activity_jumprope_match_splus_202409_rewards',
  component: RewardsSplus202409,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的奖品',
  },
}

export const rewardsMetaSVS2024Route: RouteConfig = {
  path: '/activity/jumprope-match/metasvs-2024/rewards',
  name: 'activity_jumprope_match_metasvs_2024_rewards',
  component: RewardsMetaSVS2024,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的奖品',
  },
}

export const physicalRewardSizeEditRoute: RouteConfig = {
  path: '/activity/jumprope-match/361du/physical-reward-size-edit',
  name: 'activity_jumprope_match_361du_physical_reward_size_edit',
  component: PhysicalRewardSizeEdit,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '尺码选择',
  },
}

export const physicalRewardSizeEditMetaSVS2024Route: RouteConfig = {
  path: '/activity/jumprope-match/metasvs-2024/physical-reward-size-edit',
  name: 'activity_jumprope_match_metasvs_2024_physical_reward_size_edit',
  component: PhysicalRewardSizeEditMetaSVS2024,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '尺码选择',
  },
}

export default [
  indexRoute,
  indexMetaSVS2024Route,
  indexSplus202409Route,
  rewardsSplus202409Route,
  rewardsMetaSVS2024Route,
  physicalRewardSizeEditRoute,
  physicalRewardSizeEditMetaSVS2024Route,
]
